export default {
  company: 'Ormiston Endoscopy',
  companyShort: 'Ormiston',
  phone: '(09) 250 1157',
};
